import native from '@zz-common/native-adapter/es/all'
import { legic } from '@lib/legic'
import {
  day,
  cookie,
  isEmptyData,
  env,
  parseParams as parseUrlParams,
  url
} from '@zz-yp/hunter-js-utils'
import { miniInterceptor } from './miniAuth'
import { LegoPerformance } from '@zz-common/lego'
import router from '@/router'

/**
 * 将adapter的login转为promise的返回值
 * @returns {Promise<any>}
 */
const login = () => {
  return new Promise((resolve) => {
    native.login({
      isHunter: true,
      callback: (res) => {
        resolve(res)
      }
    })
  })
}

/**
 * 控制页面登录状态
 * @returns {Promise<boolean>}
 */
export const needLogin = async function (targetUrl = location.href) {
  if (!isEmptyData(cookie.getPPU())) return true

  const interceptRes = await miniInterceptor(targetUrl)
  if (!interceptRes) return false // mini 取消登录

  const res = await login()
  return res && res.code == 0
}

export const getCookie = function (name) {
  return cookie.get(name)
}

export const setCookie = function (name, value) {
  const expires = 30
  const path = '/'
  cookie.set(name, value, {
    expires,
    domain: '.zhuanzhuan.com',
    path
  })
  cookie.set(name, value, {
    expires,
    domain: '.caihuoxia.com',
    path
  })
}

export const isVideo = (url) => {
  const isVideoReg = /(mp4|avi|m3u8|rmvb)$/
  return isVideoReg.test(url.toLowerCase())
}

export const isAndroid = () => {
  return env.$isAndroid
}

export const isIos = () => {
  return env.$isIOS
}

/**
 * url参数拼接
 * @param uri
 * @param params
 * @returns {*}
 */
export const parseParams = (uri, newParams) => {
  return parseUrlParams(uri, newParams)
}

/**
 * decoratorUrl 统一处理域名 兼容
 * @param {String} targetUrl 跳转url
 */

export const decoratorUrl = (targetUrl) => {
  try {
    if (!targetUrl) return
    targetUrl = targetUrl.trim()
    // 需要判断的项目链接 目前只针对这三个项目的链接做判断
    const replaceDomain = /(\/u\/hunter-market|\/u\/hunter-publish|\/u\/hunter_m_aftersale)/.test(
      targetUrl
    )
    if (!replaceDomain) return targetUrl
  } catch (err) {
    alert('链接不合法')
  }

  const { host } = window.location
  try {
    // 将链接转成URL
    const urlObj = new URL(targetUrl)
    const { pathname, search } = urlObj
    // 如果是这三个项目的链接 则替换跳转链接的域名 为host(window.location)
    return `https://${host || 'm.caihuoxia.com'}${pathname}${search}`
  } catch (err) {
    alert(`${targetUrl}链接不合法`)
  }
}

/**
 * location 统一跳转
 * @param {String} url 跳转url
 */
export const locationToUrl = (url, isReLoad = false, title = '') => {
  if (!url) return
  if (isReLoad && env.$isIOS) {
    window.onpageshow = null
    window.onpageshow = function () {
      if (title) {
        this.native.setTitle({
          title
        })
      }
    }
  }

  location.href = decoratorUrl(url)
}

/**
 * 将formdata格式的数据转成json
 * @param {formData} formData
 */
export const convertFormDataToJson = (formData) => {
  const objData = {}
  formData.forEach((value, key) => (objData[key] = value))
  return JSON.stringify(objData)
}

/**
 * 是否是数组中任何一项的子串
 * @param {Array} arr 目标数组
 * @param {String} curStr 当前字符串
 */
export const isMatchArrayAnyone = (arr, curStr) => {
  const len = arr.length
  let isHas = false
  for (let i = 0; i < len; i++) {
    if (arr[i].indexOf(curStr) > -1) {
      isHas = true
      break
    }
  }
  return isHas
}
/**
 * 时间格式化
 * @param {string | number} timeStamp 时间戳
 * @param {string} template 格式模板，只支持 yyyy MM dd HH mm ss 这六种形式，但可以增删组合
 */
export const formatTime = (timeStamp, template = 'YYYY-MM-DD HH:mm:ss') => {
  const toNum = Number(timeStamp)
  if (toNum) {
    return day(toNum).format(template)
  }
  return day().format(template)
}

/**
 * 获取客户端预请求的数据
 * curKey ：当前的keys
 */
export const getPreloadedDataHandle = (curKey) => {
  return new Promise((resolve) => {
    let preloadedData = null
    // 只有在采货侠客户端才执行
    if (native.in('zzhunter')) {
      native.wrap('getPreloadedData')((res) => {
        // 此层为客户端数据格式   res.data 为所有接口的集合{key:value, key2:value2}
        if (res.code == 0 && res.data) {
          const length = Object.keys(res.data || {}).length
          if (length) {
            preloadedData = res.data[curKey] || null
          }
        }
        /**
         * @log 客户端预请求 - 使用
         * @backup {project: 项目, keys:当前页面的成功请求回来的key, type: 数据来源 }
         */
        legic('', 'preloaded-usage', {
          type: preloadedData ? 'nativeData' : 'h5Data',
          project: 'market',
          keys: Object.keys(res.data || {}),
          curUrl: location.href
        })
        resolve(preloadedData)
      })
      // 为了解决hunter-jssdk cb时 parse的错误（sdk的调用处较多，暂不在sdk源码处理）
      // 此方式执行的频率可以通过埋点查询。此方案是兜底
      setTimeout(() => {
        if (!preloadedData) {
          /**
           * @log 客户端预请求 - 使用
           * @backup {project: 项目}
           */
          legic('', 'preloaded-usage-error', {
            project: 'market',
            keys: curKey,
            curUrl: location.href
          })
          resolve(preloadedData)
        }
      }, 100)
    } else {
      resolve(preloadedData)
    }
  })
}

/**
 * 接口速度竞争的回调，主要绑定H5接口执行完成状态
 * @param {String} type set
 * @param {String} cdName 唯一的函数名: 取自于函数的name
 * @param {Function} cb 回调
 */
export const interfaceCompeteInSpeedCb = (type, cdName, cb) => {
  console.log('cdName-------', type, cdName)
  if (type === 'set') {
    window[cdName] = cb
    return
  }
  if (window[cdName]) {
    window[cdName]()
    window[cdName] = null
  }
}

/**
 * 接口速度竞争 - 比较客户端接口及H5接口
 * @param {Function} h5Get 接口函数的调用指针
 * @param {Object} params 当需要在客户端执行后的回调内使用参数，可以传入这个字段，若传入，记得留意接口处接收是否兼容 如：h5Get 原函数有参数使用
 * @param {Function} callback 回调
 */
export const interfaceCompeteInSpeed = (h5Get, params, callback) => {
  const nativeData = new Promise((resolve) => {
    native.wrap('getPreloadedData')((res) => {
      // 此层为客户端数据格式   res.data 为所有接口的集合{key:value, key2:value2}
      if (res.code == 0 && res.data) {
        const length = Object.keys(res.data || {}).length
        if (length) {
          resolve({ type: 'nativeData', resultData: res.data })
        }
      }
    })
  })

  const h5Data = new Promise((resolve) => {
    // 主要使业务侧告诉竞速结束, 理论是客户端一定快，所以算是兜底
    interfaceCompeteInSpeedCb('set', h5Get.name, () => {
      resolve({ type: 'h5Data', resultData: {} })
    })
    // 发起H5侧请求
    h5Get(params)
  })

  Promise.race([nativeData, h5Data]).then((data) => {
    // console.log('interfaceCompeteInSpeed-data---------', data)
    /**
     * @log 客户端预请求 - 使用
     * @backup {project: 项目, keys:当前页面的成功请求回来的key, type: 数据来源 }
     */
    legic('', 'preloaded-usage', {
      type: data.type,
      project: 'market',
      keys: Object.keys(data.resultData || {}),
      curUrl: location.href
    })
    // eslint-disable-next-line n/no-callback-literal
    callback({
      ...data,
      originParams: params
    })
  })
}

/**
 * 预渲染处理函数， 用于在预渲染过程中执行一些操作，在预渲染页面mounted中使用
 * @param {Function} cb 页面真正展示时执行回调函数
 * @returns {void}
 */
export const preRenderHooks = (cb) => {
  // 预渲染
  if (window.zzPreRender) {
    window.zzPreRender.viewCreated(location.href)
    window.zzPreRender.onViewWillAppear = (msg) => {
      // jumUrl是当前页面的真实url，包好了页面需要的业务参数
      const { jumpUrl } = (msg && msg.detail) || {}
      if (!jumpUrl) {
        return
      }
      // 重要修改本地location.href的值,方便其它业务使用，并且保障location.href与实际页面一致
      const query = url.getParams(jumpUrl)
      router.replace({
        query
      })
      // 发送性能卖点
      try {
        setTimeout(() => {
          new LegoPerformance()
            .set({
              isprerender: 1,
              atfTime: 100,
              fmp: 100,
              firstPiantTime: 100,
              loadTime: 100
            })
            .send()
        }, 100)
      } catch (error) {
        console.error('fixPerf error', error)
      }
      if (cb && typeof cb === 'function') {
        cb()
      }
    }
  }
}
